import { DEFAULT_VALUE, EMPTY_VALUE } from "@wix/form-fields";
const fillEmptyValues = (form, values, recursive = true) => {
  if (!form?.fields) {
    return {};
  }
  return form.fields.reduce((result, field) => {
    const fieldTarget = field.target;
    if (!fieldTarget) {
      return result;
    }
    const fieldValue = values?.[fieldTarget];
    const defaultValue = field.view?.defaultValue;
    const fieldType = field.view?.fieldType;
    const nestedForm = field.view?.form;
    if (recursive && nestedForm) {
      result[fieldTarget] = fillEmptyValues(
        nestedForm,
        fieldValue,
        false
      );
    } else if (fieldValue !== void 0) {
      result[fieldTarget] = fieldValue;
    } else if (defaultValue !== void 0) {
      result[fieldTarget] = DEFAULT_VALUE[fieldType]?.(field);
    } else if (fieldType) {
      result[fieldTarget] = EMPTY_VALUE;
    }
    return result;
  }, {});
};
export {
  fillEmptyValues
};
//# sourceMappingURL=form-values.js.map
